import FoodOrdersListPanel from '../../components/food/FoodOrdersListPanel';
import PageShell from '../../components/layout/PageShell';
import PageHeader from '../../components/layout/PageHeader';

export default function MerchantFoodScheduledOrdersPage() {
  return (
    <PageShell>
      <PageHeader
        title="Scheduled Food Orders"
        subtitle="Upcoming scheduled restaurant orders"
      />
      <FoodOrdersListPanel
        scope="scheduled"
        title="Scheduled food orders"
        queryKeyPrefix="merchant-food-scheduled"
      />
    </PageShell>
  );
}
